// Define query keys here that we will use in useQuery hook.
// This is to insure consistency across the app when using useQuery and invalidateQueries.
// If there is inconsistencies when using useQuery and invalidateQuires, unexpected behavior will occur.

export const keys = {
  ACCOUNT_LISTS: 'lists', // key for account lists
  REWARDS: 'rewards', // key for rewards
  LATEST_ARTICLES: 'latestArticles', // key for last articles
  VIDEO_ARTICLES: 'videoArticles', // key for video articles
  ARTICLES: 'articles', // key for articles list
  API_KEYS: 'apiKeys', // key for api keys
  API_DATA_POINTS: 'apiDataPoints', // key for api data points
};
